/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum DataSyncTypeType {
  Encounter = 'Encounter',
  Patient = 'Patient',
  Protocol = 'Protocol'
}
